export const ASSET_TYPES = {
  MODEL: '3D model',
  IMAGE: 'Image',
  SLIDES: 'Slides',
  DATASHEET: 'Datasheet',
  VIDEO: 'Video',
  COLORCODE: 'Colorcode',
  ORTHO: 'Ortho'
};

export const ASSET_TYPES_BE = {
  MODEL: 'Model',
  IMAGE: 'Image',
  SLIDES: 'Slides',
  DATASHEET: 'Datasheet',
  VIDEO: 'Video',
  COLORCODE: 'Colorcode',
  ORTHO: 'Ortho',
  MWC: 'Mwc'
};

export const FILE_TYPES = {
  JPG: '.jpg',
  PDF: '.pdf',
  GLB: '.glb',
  PNG: '.png',
  SVG: '.svg',
  MP4: '.mp4'
}

export const DEFAULT_ASSETS_TYPE = 'Model';
